import { render } from "./AiFooter.vue?vue&type=template&id=1321fc68&scoped=true"
import script from "./AiFooter.vue?vue&type=script&lang=js"
export * from "./AiFooter.vue?vue&type=script&lang=js"

import "./AiFooter.vue?vue&type=style&index=0&id=1321fc68&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1321fc68"]])

export default __exports__